import React, {Fragment} from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Salman from '../../assets/team/salman.svg'
import Arta from '../../assets/team/arta.svg'
import Nicolas from '../../assets/team/Nicolas.svg'
import Weiwei from '../../assets/team/Weiwei.svg'
import Robin from '../../assets/team/Robin.svg'
import Shahid from '../../assets/team/Shahid.svg'
import Carl from '../../assets/team/carl.svg'
import Olof from '../../assets/team/olof.svg'
import Daniel from '../../assets/team/Daniel.svg'
import AlbertTeam from '../../assets/team/albert_team.svg'
import MRAlbert from '../../assets/team/albert-maskot.svg'
import Pardeep from '../../assets/team/pardeep.svg'
import Felicia from '../../assets/team/felicia.svg'
import Sebastian from '../../assets/team/sebastian.svg'



class Content extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        const {angelica_team, ismar_team, stephanie_team, lucie_team, richard_team, pontus_team, mralbert_team} = this.props.query;
        return(
            <Fragment>
                <section className="all-animals">
                    <div className="custom-container">
                        <h3>Teamet bakom Albert</h3>
                        <ul>
                            <li>
                                <figure><Salman /></figure>
                                <figcaption>
                                    <h4>Salman</h4>
                                    <p>Medgrundare</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><Arta /></figure>
                                <figcaption>
                                    <h4>Arta</h4>
                                    <p>Medgrundare</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><Nicolas /></figure>
                                <figcaption>
                                    <h4>Nicolas</h4>
                                    <p>Head of Marketing</p>	
                                </figcaption>
                            </li>
                            <li>
                                <figure><Weiwei /></figure>
                                <figcaption>
                                    <h4>Weiwei</h4>
                                    <p>UI/UX Designer</p>	
                                </figcaption>
                            </li>
                            <li>
                                <figure><img src={angelica_team.publicURL}/></figure>
                                <figcaption>
                                    <h4>Angelica</h4>
                                    <p>Digital Designer</p>	
                                </figcaption>
                            </li>
                            {/* <li>
                                <figure><img src={stephanie_team.publicURL}/></figure>
                                <figcaption>
                                    <h4>Stephanie</h4>
                                    <p>Produktägare</p>	
                                </figcaption>
                            </li> */}
                            
                            <li>
                                <figure><Robin /></figure>
                                <figcaption>
                                    <h4>Robin</h4>
                                    <p>Head of Mathematics</p>	
                                </figcaption>
                            </li>
                            <li>
                                <figure><Shahid /></figure>
                                <figcaption>
                                    <h4>Marcus</h4>
                                    <p>CTO</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><Carl /></figure>
                                <figcaption>
                                    <h4>Carl </h4>
                                    <p>Projektledare</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><img src={lucie_team.publicURL}/></figure>
                                <figcaption>
                                    <h4>Lucie </h4>
                                    <p>Systemutvecklare</p>	
                                </figcaption>
                            </li>
                            
                            
                            <li>
                                <figure><img src={pontus_team.publicURL}/></figure>
                                <figcaption>
                                    <h4>Pontus </h4>
                                    <p>Systemutvecklare</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><AlbertTeam /></figure>
                                <figcaption>
                                    <h4>Albert </h4>
                                    <p>Systemutvecklare</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><img src={richard_team.publicURL} /></figure>
                                <figcaption>
                                    <h4>Richard </h4>
                                    <p>UI/UX Designer</p>	
                                </figcaption>
                            </li>
                            <li>
                                <figure><Sebastian /></figure>
                                <figcaption>
                                    <h4>Sebastian </h4>
                                    <p>Produktägare</p>	
                                </figcaption>
                            </li>
                            
                            
                            
                            
                            <li>
                                <figure><img src={ismar_team.publicURL}/></figure>
                                <figcaption>
                                    <h4>Ismar </h4>
                                    <p>Systemutvecklare</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><Olof/></figure>
                                <figcaption>
                                    <h4>Ólöf </h4>
                                    <p>Systemutvecklare</p>	
                                </figcaption>
                            </li>
                            
                            <li>
                                <figure><Felicia /></figure>
                                <figcaption>
                                    <h4>Felicia </h4>
                                    <p>Content Manager</p>	
                                </figcaption>
                            </li>
                            

                            <li>
                                <figure><Pardeep /></figure>
                                <figcaption>
                                    <h4>Pardeep </h4>
                                    <p>Systemutvecklare</p>	
                                </figcaption>
                            </li>
                            <li>
                                <figure><MRAlbert /></figure>
                                <figcaption>
                                    <h4>Albert </h4>
                                    <p>Maskot</p>	
                                </figcaption>
                            </li>
                            <li>
                                <figure><Daniel /></figure>
                                <figcaption>
                                    <h4>Ida </h4>
                                    <p>Kundservice</p>	
                                </figcaption>
                            </li>
                            
                            
                        </ul>
                    </div>
                </section>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    angelica_team: file(relativePath: {regex: "/Angelica/"}) {
                        publicURL
                    }
                    stephanie_team: file(relativePath: {regex: "/Stephanie/"}) {
                        publicURL
                    }
                    ismar_team: file(relativePath: {regex: "/Ismar/"}) {
                        publicURL
                    }
                    lucie_team: file(relativePath: {regex: "/Lucie/"}) {
                        publicURL
                    }
                    richard_team: file(relativePath: {regex: "/Richard/"}) {
                        publicURL
                    }
                    pontus_team: file(relativePath: {regex: "/Pontus/"}) {
                        publicURL
                    }
                    mralbert_team: file(relativePath: {regex: "/mrAlbert/"}) {
                        publicURL
                    }
                    
                }
                
                `
            }
        render={(data)  => (
           <Content query={data} {...props}/>
        )}
    />
)
